import script from "./AppIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppIcon.vue?vue&type=script&setup=true&lang=ts"

import "./AppIcon.vue?vue&type=style&index=0&id=3f4c90ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4c90ea"]])

export default __exports__